/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../../SharedModules/Table/tableGrid';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import NDCColumnCustomComponent from '../../../NDC/component/NDCColumnCustomComponent';
import { NDC_DRUG_TABLEHAD } from '../../../NDC/utility/tableHeads';
import {
  searchClaimByNDC,
  setClaimDetailsTableRowSelected,
  setClaimErrorPopupMessage,
  setDisplayClaimSearchScreenObj,
  setEditedRows,
} from '../../store/action';
import { handleScrollToEvent } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { getOverrideDefaultData } from '../../../../Maintain/RebateProgram/MaintainRebate/store/actions';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

const ClaimsDetailsTable = ({
  showFullScreen = true,
  fullScreen,
  setFullScreen,
  setError,
}) => {
  const dispatch = useDispatch();
  const claimDetailsTableData = useSelector(
    (state) => state.sharedState.claim.claimDetailsTableData
  );

  const claimSelectByFilter = useSelector(
    (state) => state.sharedState.claim.claimSelectByFilter
  );
  const claimCategoryCode = useSelector(
    (state) => state.sharedState.claim.claimCategoryCode
  );

  const invoiceSelected = useSelector(
    (state) => state.sharedState.claim.invoiceSelected
  );
  const searchScreenReduxObj = useSelector(
    (state) => state.sharedState.claim?.searchScreenReduxObj
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);
  const [applyFilter, setApplyFilter] = useState(false);
  const [confirmAction, setConfirmAction] = React.useState(false);


  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };

  const checkCondition = () => {
    const errorMessage = [];
    const headerError = {};
    handleScrollToEvent();
    const setPaidQTRError = () => {
      const message =
        '“Please enter a valid date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as ‘1Q98’ or ‘1Q1998’.';
      if (errorMessage.findIndex((item) => item === message) === -1) {
        errorMessage.push(message);
      }
    };
    if (!claimSelectByFilter || !claimSelectByFilter.paidQtr) {
      errorMessage.push('A Paid date or quarter is required.');
      headerError.paidQtr = true;
    }
    if ((!claimSelectByFilter || !claimSelectByFilter.rebateProgramCd || claimSelectByFilter.rebateProgramCd==='-1') &&
      (!userDefaults?.rebateProgramCd || userDefaults?.rebateProgramCd==='-1')
    ) {
      errorMessage.push('Rebate Program is required.');
      headerError.rebateProgramError = true;
    }
    if (claimCategoryCode==='-1'||!claimCategoryCode||(Array.isArray(claimCategoryCode) && claimCategoryCode?.length===0)
    ) {
      errorMessage.push('Claim Category Code is required.');
      headerError.claimCategoryError = true;
    }

    if (claimSelectByFilter && claimSelectByFilter.paidQtr) {
      if (
        claimSelectByFilter.paidQtr.includes('/') &&
        !claimSelectByFilter.paidQtr.includes('Q')
      ) {
        const splitQTR = claimSelectByFilter.paidQtr.split('/');
        if (splitQTR.length === 2 || splitQTR.length === 3) {
          if (
            splitQTR.length === 2 &&
            (splitQTR[0].length !== 2 ||
              (splitQTR[1].length !== 2 && splitQTR[1].length !== 4))
          ) {
            setPaidQTRError();
            headerError.paidQtr = true;
          } else if (
            splitQTR.length === 3 &&
            (splitQTR[0].length !== 2 ||
              splitQTR[1].length !== 2 ||
              (splitQTR[2].length !== 2 && splitQTR[2].length !== 4))
          ) {
            setPaidQTRError();
            headerError.paidQtr = true;
          } else if (
            (splitQTR.length === 2 && splitQTR[0] > 12) ||
            (splitQTR.length === 3 && splitQTR[0] > 12)
          ) {
            setPaidQTRError();
            headerError.paidQtr = true;
          }
        } else {
          setPaidQTRError();
          headerError.paidQtr = true;
        }
      } else if (
        !claimSelectByFilter.paidQtr.includes('/') &&
        claimSelectByFilter.paidQtr.includes('Q')
      ) {
        const splitQTR = claimSelectByFilter.paidQtr.split('Q');
        if (splitQTR.length === 2) {
          if (
            splitQTR.length === 2 &&
            (splitQTR[0].length !== 1 ||
              (splitQTR[1].length !== 2 && splitQTR[1].length !== 4))
          ) {
            setPaidQTRError();
            headerError.paidQtr = true;
          }
        } else {
          setPaidQTRError();
          headerError.paidQtr = true;
        }
      } else {
        setPaidQTRError();
        headerError.paidQtr = true;
      }
    }

    if (claimSelectByFilter && claimSelectByFilter.processedQtr) {
      if (claimSelectByFilter.processedQtr.includes('Q')) {
        const splitQTR = claimSelectByFilter.processedQtr.split('Q');
        if (splitQTR.length === 2) {
          if (
            splitQTR.length === 2 &&
            (splitQTR[0].length !== 1 ||
              (splitQTR[1].length !== 2 && splitQTR[1].length !== 4))
          ) {
            setPaidQTRError();
            headerError.processedQtr = true;
          }
        } else {
          setPaidQTRError();
          headerError.processedQtr = true;
        }
      } else {
        setPaidQTRError();
        headerError.processedQtr = true;
      }
    }

    if (
      claimSelectByFilter &&
      ((claimSelectByFilter.providerIdTypeCd &&
        (!claimSelectByFilter.providerId ||
          !claimSelectByFilter.providerId.trim())) ||
        (!claimSelectByFilter.providerIdTypeCd &&
          claimSelectByFilter.providerId &&
          claimSelectByFilter.providerId.trim()))
    ) {
      errorMessage.push('Please enter Provider ID Type with Provider.');
      headerError.providerError = true;
    }

    if (!invoiceSelected.invoiced && !invoiceSelected.nonInvoiced) {
      errorMessage.push('You must check one of the invoice check boxes.');
    }

    if (errorMessage.length > 0) {
      setError(headerError);
      dispatch(setClaimErrorPopupMessage(errorMessage));
      return false;
    }
    setError(true);
    dispatch(setClaimErrorPopupMessage(null));
    return true;
  };

  const handleViewDetailsClick = async () => {
    dispatch(setEditedRows([]));
    dispatch(
      setDisplayClaimSearchScreenObj({
        ...searchScreenReduxObj,
        isibwdndc: false,
        isibwdclaim: false,
      })
    );
    if (checkCondition()) {
      if (claimDetailsTableData.length > 1000) {
        setConfirmAction(true);
        return;
      }
      if (claimDetailsTableData.length === 0) {
        dispatch(setClaimErrorPopupMessage('You have not selected any NDCs.'));
        handleScrollToEvent();
      } else {
        dispatch(searchClaimByNDC());
        dispatch(
          getOverrideDefaultData({
            planTypeCd: userDefaults?.planTypeCd,
            rebateProgramCd: claimSelectByFilter?.rebateProgramCd,
          })
        );
      }
    }
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, claimDetailsTableData]);

  const onSelectionChanged = useCallback(() => {
    dispatch(setClaimDetailsTableRowSelected(gridApi.getSelectedRows()));
  }, [gridApi]);
  return (
    <>
      {!fullScreen && (
        <div className="d-flex align-items-center justify-content-end">
          <Button
            className="btn btn-success btn-view"
            onClick={() => handleViewDetailsClick()}
          >
            <SVGComponent iconName="Icon-view" />
            View Claim Detail
          </Button>
        </div>
      )}
      <TableFilterHeader
        gridApi={gridApi}
        columnApi={columnApi}
        childRef={childRef}
        showFullScreen={showFullScreen}
        applyFilter={applyFilter}
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        showHistory={false}
        fileName="NDC Details"
        resetFilterFunc={resetFilters}
        className="mt-2 mb-1 border-bottom"
      />
      <div className="table-container eightRecords">
        <Grid
          gridHeight={fullScreen ? '100vh' : 350}
          ref={childRef}
          rowData={claimDetailsTableData}
          columnDefs={NDC_DRUG_TABLEHAD}
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          rowSelection="multiple"
          isScrollOn
          onSelectionChanged={onSelectionChanged}
          frameworkComponents={{
            ndcComponent: NDCColumnCustomComponent,
            nameRenderNdcDrugName: (cellInfo) => {
              const name = cellInfo.data && cellInfo.data.drugName;
              if (name && name.length > 21) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
          onFilterChanged={(e) => {
            setTableCount(e.api.getDisplayedRowCount());
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
        />
        <p className="total-results" tabIndex="0">
          Total Results: <b>{tableCount?.toLocaleString('en-US')}</b>
        </p>
      </div>
        <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          dispatch(searchClaimByNDC(true, true));
          setConfirmAction(false);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
      />
    </>
  );
};

export default ClaimsDetailsTable;
